//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import distributionRegionMixin from '@/mixins/distributionRegion';
import { getCommissionList } from '@/api/distributionAlliance';
export default {
  mixins: [distributionRegionMixin],
  name: 'AllianceAgentProfit',
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: {
        agentId: null,
        uid: null,
        status: null,
        regionPrefix: '',
        page: 1,
        size: 20
      }
    };
  },
  created: function created() {
    this.load(1);
  },
  methods: {
    load: function load(page) {
      var _this = this;
      if (page) this.query.page = page;
      this.loading = true;
      // 只看代理侧：团长侧的明细在「团长业绩」页，两边混在一起对账时要先自己筛一遍
      var params = {
        role: 'AGENT',
        page: this.query.page,
        size: this.query.size
      };
      ['agentId', 'uid', 'regionPrefix'].forEach(function (key) {
        if (_this.query[key]) params[key] = _this.query[key];
      });
      if (this.query.status !== null && this.query.status !== '') params.status = this.query.status;
      getCommissionList(params).then(function (res) {
        _this.list = res && res.list || [];
        _this.total = res && res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    reset: function reset() {
      this.query = {
        agentId: null,
        uid: null,
        status: null,
        regionPrefix: '',
        page: 1,
        size: 20
      };
      this.load(1);
    },
    onSize: function onSize(size) {
      this.query.size = size;
      this.load(1);
    },
    /** 只合计本页的分成金额，并写明「本页」——写成总计会被当成全量合计 */summary: function summary(_ref) {
      var columns = _ref.columns,
        data = _ref.data;
      return columns.map(function (col, index) {
        if (index === 0) return '本页合计';
        if (col.label !== '分成金额') return '';
        var sum = data.reduce(function (acc, row) {
          return acc + Number(row.commissionAmount || 0);
        }, 0);
        return "\xA5".concat(sum.toFixed(2));
      });
    },
    roleText: function roleText(role) {
      return {
        AGENT: '区代',
        AGENT_ORIGIN: '招募代理',
        AGENT_CITY: '市代',
        AGENT_PROVINCE: '省代',
        DEALER: '经销商'
      }[role] || role;
    },
    statusText: function statusText(status) {
      return {
        0: '待结算',
        1: '到账等待期',
        2: '可提现',
        3: '已失效',
        4: '提现申请中',
        5: '已提现',
        6: '待周期结算'
      }[status] || '—';
    },
    statusType: function statusType(status) {
      if (status === 2 || status === 5) return 'success';
      if (status === 3) return 'info';
      return 'warning';
    }
  }
};